/* eslint-disable @typescript-eslint/ban-ts-comment */
import { ReactNode, useCallback } from "react";

import Loading from "web/Layout/Common/Loading/loading";

import ModalNotification from "web/hooks/useModalNotification/ModalNotification/modalNotification";

import type { Nullable } from "web/types/Utils";

import { useAppContext } from "web/context/app";

import { ModalActionTypes } from "../useModal/useModalTypes";

// eslint-disable-next-line import/prefer-default-export
const useModalNotification = () => {
  const { modal } = useAppContext();
  let timer: NodeJS.Timeout;

  const { dispatch } = modal;

  const setModal = useCallback(
    (content: ReactNode) => {
      dispatch({ type: ModalActionTypes.ADD_MODAL, modal: content });
    },
    [dispatch]
  );

  const closeModal = useCallback(() => {
    dispatch({ type: ModalActionTypes.RESET });
  }, [dispatch]);

  const setModalNotification = (
    text: string,
    duration: Nullable<number> = null,
    onCloseModal = null
  ) => {
    if (duration) {
      timer = setTimeout(() => {
        closeModal();
        // @ts-ignore
      }, [duration * 1000]);
    }
    setModal(
      <ModalNotification
        textInfo={text}
        timer={timer}
        onCloseModal={onCloseModal}
      />
    );
  };

  const setModalLoaderNotification = () => {
    setModal(<ModalNotification component={<Loading />} />);
  };

  return [setModalNotification, setModalLoaderNotification];
};

export default useModalNotification;
